import ReactDOM from "react-dom/client";
import "./index.css";
import AdminApp from "./AdminApp";

const queryParams = new URLSearchParams(window.location.search);
const tenantId = queryParams.get("tenantId");

if (tenantId) {
  // If a tenantId is found in the URL, save it immediately.
  sessionStorage.setItem("tenantId", tenantId);
  console.log("tenantId from URL has been set in sessionStorage.");

  // Optional: Remove the query parameter from the URL for a cleaner look
  window.history.replaceState(null, "", window.location.pathname);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AdminApp />);
